import {CardElement, useElements, useStripe} from '@stripe/react-stripe-js';
import {
    Button,
    Container, FormControl,
    Grid,
    Icon, InputLabel, MenuItem, Select,
    TextField
} from "@mui/material";
import {makeStyles, withStyles} from "@mui/styles";
import React from "react";
import StripeInput from "./StripeInput";
import clsx from "clsx";
import Typography from "@mui/material/Typography";
import {getCountryList, showAlertAutoDis} from "../../../utils/utils";

const NautilusTextInput = withStyles({
    root: {
        backgroundColor: 'white',
        '& label.Mui-focused': {
            color: '#1ebce7',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#1ebce7',
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: 2,
            // '& fieldset': {
            //     borderColor: 'red',
            // },
            '&:hover fieldset': {
                borderColor: '#1ebce7',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#1ebce7',
            },
        },
    },
})(TextField);
const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
        lineHeight: 1.5,
        backgroundColor: '#02ba04',
        borderColor: '#02ba04',
    },
    root: {
        '& .MuiPaper-elevation1': {
            boxShadow: 'none'
        }
    }
}));

export default function ParkFeeCheckoutForm({setBilling, billingDetails, sendStripeToken}) {

    const stripe = useStripe();
    const elements = useElements();
    const countryList = getCountryList();
    const classes = useStyles();
    const handleChange = event => {
        setBilling(event);
    };
    const handleSubmit = async event => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make  sure to disable form submission until Stripe.js has loaded.
            return;
        }
        const cover = $('#cover');
        cover.show();
        const card = elements.getElement(CardElement);
        const result = await stripe.createToken(card);
        cover.hide();
        if (result.error) {
            // Show error to your billingDetails.
            showAlertAutoDis({title: 'Payment Process', text: result.error.message});
            // console.log(result.error.message);
        } else {
            // Send the token to your server.
            // This function does not exist yet; we will define it in the next step.
            await sendStripeToken(result.token);
        }
    };
    return (
        <Container maxWidth={'sm'} style={{minWidth: 350}} className={classes.root}>
            <form className={'formPayment'} noValidate onSubmit={handleSubmit}>
                <Grid container direction="row" justify="center" alignItems="center" style={{paddingBottom: 30}}>
                    <Grid item xs={12} style={{padding: 10}}>
                        <NautilusTextInput
                            label="Credit Card"
                            name="creditCard"
                            variant="outlined"
                            required
                            fullWidth
                            InputLabelProps={{shrink: true}}
                            InputProps={{
                                inputComponent: StripeInput,
                                inputProps: {
                                    component: CardElement
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container direction="row" justify="center" alignItems="center"
                              style={{paddingBottom: 30}}>
                            <Grid item xs={12} style={{padding: 10}}>
                                <Typography variant="h5" component="h5" align="center">
                                    Billing Details<br/>
                                </Typography>
                            </Grid>
                            <Grid item xs={12} style={{padding: 10}}>
                                {/*<NautilusTextInput
                                    label="Country"
                                    name="country"
                                    variant="outlined"
                                    value={billingDetails && 'country' in billingDetails ? billingDetails['country'] : ''}
                                    onChange={handleChange}
                                    fullWidth
                                />*/}
                                <FormControl fullWidth>
                                    <InputLabel id="countryLabel">Country</InputLabel>
                                    <Select
                                        labelId="countryLabel"
                                        id="country"
                                        name="country"
                                        label="Select Country"
                                        value={billingDetails && 'country' in billingDetails ? billingDetails['country'] : ''}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value={''}>Select Country</MenuItem>
                                        {countryList.map(country => (
                                            <MenuItem key={country.code}
                                                      value={country.code}>{country.name}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} style={{padding: 10}}>
                                <NautilusTextInput
                                    label="State"
                                    name="state"
                                    value={billingDetails && 'state' in billingDetails ? billingDetails['state'] : ''}
                                    onChange={handleChange}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} style={{padding: 10}}>
                                <NautilusTextInput
                                    label="City"
                                    name="address_city"
                                    value={billingDetails && 'address_city' in billingDetails ? billingDetails['address_city'] : ''}
                                    onChange={handleChange}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} style={{padding: 10}}>
                                <NautilusTextInput
                                    label="Address (Line 1)"
                                    name="address_line1"
                                    value={billingDetails && 'address_line1' in billingDetails ? billingDetails['address_line1'] : ''}
                                    onChange={handleChange}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} style={{padding: 10}}>
                                <NautilusTextInput
                                    label="Address (Line 2)"
                                    name="address_line2"
                                    value={billingDetails && 'address_line2' in billingDetails ? billingDetails['address_line2'] : ''}
                                    onChange={handleChange}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} style={{padding: 10}}>
                                <NautilusTextInput
                                    label="Postal code"
                                    name="address_zip"
                                    value={billingDetails && 'address_zip' in billingDetails ? billingDetails['address_zip'] : ''}
                                    onChange={handleChange}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} style={{padding: 10}}>
                                <NautilusTextInput
                                    label="Name"
                                    name="name"
                                    value={billingDetails && 'name' in billingDetails ? billingDetails['name'] : ''}
                                    onChange={handleChange}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={12} style={{padding: 10}}>
                                <NautilusTextInput
                                    label="Email"
                                    name="email"
                                    value={billingDetails && 'email' in billingDetails ? billingDetails['email'] : ''}
                                    onChange={handleChange}
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{px: '10px'}}>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            fullWidth
                            className={clsx({[classes.button]: true, 'payButton': true})}
                            style={{margin: 0}}
                            startIcon={<Icon>payment</Icon>}
                            disabled={!stripe}
                        >
                            Pay
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </Container>
    )
        ;
}